import React from 'react'
import LoginForm from '../../components/LoginForm/LoginForm'

const LoginPage = (props) => { 
  return (
    <LoginForm props={props}/>
  )
}

export default LoginPage